import { render, staticRenderFns } from "./card.component.vue?vue&type=template&id=238ecd3c&scoped=true&"
import script from "./card.component.vue?vue&type=script&lang=ts&"
export * from "./card.component.vue?vue&type=script&lang=ts&"
import style0 from "./card.component.vue?vue&type=style&index=0&id=238ecd3c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238ecd3c",
  null
  
)

export default component.exports